module.exports = __webpack_public_path__ + "static/007488-8e079a91d5f6c8baf3d90eeaa59f8001.jpg";